import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { generateHeader } from 'lib/pdfs/Common';
import { formatNumber, formatMoney } from 'accounting-js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const getDepreciation = (type, record) => {
  switch (type) {
    case 'fiscal':
      return record._fiscalDepreciationResult || {};
    case 'financial':
      return record._financialDepreciationResult || {};
    default:
      return true;
  }
};

export const generateDisabledPDF = async (subcompany, endDate, type, records) => {
  const header = await generateHeader(`${subcompany.name} \nReporte de bajas`);

  const rows = records.map((r) => {
    const depreciation = getDepreciation(type, r);

    return [
      { text: r.number, style: 'tableRow' },
      { text: r.name, style: 'tableRow' },
      {
        text: r._costCenter ? `${r._costCenter.key} - ${r._costCenter.name}` : '-',
        style: 'tableRow',
      },
      {
        text: r._account ? `${r._account.key} - ${r._account.name}` : '-',
        style: 'tableRow',
      },
      {
        text: r._subaccount ? `${r._subaccount.key} - ${r._subaccount.name}` : '-',
        style: 'tableRow',
      },
      {
        text: r.disableDetail ? r.disableDetail : '-',
        style: 'tableRow',
      },
      {
        text: r.buyDate ? moment(r.buyDate).format('DD/MM/YYYY') : '-',
        style: 'tableRow',
      },
      { text: depreciation.name || '-', style: 'tableRow' },
      {
        text: r.startDate ? moment(r.startDate).format('DD/MM/YYYY') : '-',
        style: 'tableRow',
      },
      {
        text: r.disableDate ? moment(r.disableDate).format('DD/MM/YYYY') : '-',
        style: 'tableRow',
      },
      { text: formatMoney(r.price || 0), style: 'tableRow' },
      {
        text: formatNumber(depreciation.years || 0, { precision: 4 }) || '-',
        style: 'tableRow',
      },
      {
        text: formatMoney(depreciation.originalAmount || 0),
        style: 'tableRow',
      },
      {
        text: formatNumber((depreciation.factors && depreciation.factors.inpcBegin) || 0, {
          precision: 4,
        }),
        style: 'tableRow',
      },
      {
        text: formatNumber((depreciation.factors && depreciation.factors.inpcEnd) || 0, {
          precision: 4,
        }),
        style: 'tableRow',
      },
      {
        text: formatNumber((depreciation.factors && depreciation.factors.factor) || 0, {
          precision: 4,
        }),
        style: 'tableRow',
      },
      {
        text: formatMoney(depreciation.totalDepreciation || 0),
        style: 'tableRow',
      },
      { text: formatMoney(depreciation.depreciable || 0), style: 'tableRow' },
      { text: formatMoney(r.disableAmount || 0), style: 'tableRow' },
      { text: formatMoney(depreciation.refound || 0), style: 'tableRow' },
    ];
  });

  const docDefinition = {
    pageOrientation: 'landscape',
    pageSize: 'TABLOID',
    content: [
      header,
      {
        margin: [0, 10, 0, 0],
        columnGap: 20,
        columns: [
          {
            width: '*',
            text: `Fecha de valores: ${moment(endDate).format('DD/MM/YYYY')}`,
            bold: true,
            style: 'textStyle',
          },
          {
            width: '100',
            text: `Fecha: ${moment().format('DD/MM/YYYY')}`,
            style: 'textStyle',
          },
        ],
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          headerRows: 1,
          widths: [
            '5%',
            '10%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
            '5%',
          ],
          body: [
            [
              { text: 'Número', style: 'tableRow', bold: true, fontSize: 7 },
              { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 7 },
              {
                text: 'Centro de costos',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              { text: 'Cuenta', style: 'tableRow', bold: true, fontSize: 7 },
              { text: 'Tipo', style: 'tableRow', bold: true, fontSize: 7 },
              { text: 'Detalle', style: 'tableRow', bold: true, fontSize: 7 },
              {
                text: 'Fecha de compra',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Depreciación aplicada',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Fecha de aplicación',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Fecha de baja',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              { text: 'Precio', style: 'tableRow', bold: true, fontSize: 7 },
              {
                text: 'Tiempo uso (años)',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              { text: 'MOI', style: 'tableRow', bold: true, fontSize: 7 },
              {
                text: 'INPC compra',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'INPC utilización',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              { text: 'Factor', style: 'tableRow', bold: true, fontSize: 7 },
              {
                text: 'Dep. total',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Valor reposición',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Monto recuperado',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
              {
                text: 'Perdida/Ganancia',
                style: 'tableRow',
                bold: true,
                fontSize: 7,
              },
            ],
            ...rows,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === 1 ? 2 : 1;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return '#e9ecef';
          },
        },
      },
    ],
    styles: {
      textStyle: {
        color: '#45535b',
        fontSize: 11,
        margin: [0, 20, 0, 0],
      },

      tableRow: {
        color: '#45535b',
        fontSize: 6,
        margin: [10, 5, 0, 5],
      },
      tableRowOdd: {
        color: '#45535b',
        fontSize: 6,
        fillColor: '#f4f4f4',
        margin: [10, 5, 0, 5],
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
};



// WEBPACK FOOTER //
// src/lib/pdfs/DisabledPDF.js